//@vendor
const Immutable = require('immutable');
//@actions
const actionTypes = require('../../loansConstants/actionTypes');
//@constants
const { EURO_TEXT } = require('constants/index');
//@helper
const get = require('lodash/object/get');

const initialState = Immutable.fromJS({
    success: false,
    isFetching: true,
    error: false,
    details: {}
});

function prepareDetails(state, movementId, data) {
    const details =  Immutable.fromJS({
        isFetching: false,
        success: true,
        error: false,
        details: {
            capital: {
                amount: get(data, 'capital', 0),
                currency: EURO_TEXT // Loans are always in EUROS
            },
            feeAmount: {
                amount: get(data, 'importeCuota', 0),
                currency: EURO_TEXT // Loans are always in EUROS
            },
            interest: {
                amount: get(data, 'interes', 0),
                currency: EURO_TEXT // Loans are always in EUROS
            }
        }
    });

    return state.mergeDeep(details);
}

//This is a subreducer
function loanMovementsDetails(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS:
            return state.mergeDeep(initialState);
        case actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS_SUCCESS:
            return prepareDetails(state, action.payload.movementId, action.payload.data);
        case actionTypes.FETCH_LOAN_MOVEMENTS_DETAILS_FAILURE:
            return state.mergeDeep({
                'error': action.payload.error,
                'isFetching': false
            });
        default:
            return state;
    }
}

module.exports = loanMovementsDetails;
